<div class="dropdown-container ag-popup-editor">
   <div class="dropdown" container="body" ngbDropdown>
		<button ngbDropdownToggle
		  type="button"
		  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
		  aria-haspopup="true"
		  aria-expanded="false"
		  [attr.aria-label]="LOCALIZATION.more"
		  title="{{LOCALIZATION.more}}"
		  style="border: 0; background: transparent;">
			<i class="result-nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
		</button>								  
        <ul class="dropdown-menu custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
	        <li *ngIf="record.geo && mapViewEnabled" role="menuitem">
	        	<a title="{{LOCALIZATION.viewInMap}}" (click)="openInMap($event)">{{LOCALIZATION.viewInMap}}</a>
	        </li>
	        <li role="menuitem">
	        	<a title="{{LOCALIZATION.viewMetadata}}" (click)="viewMetadata($event)">{{LOCALIZATION.viewMetadata}}</a>
	        </li>
	        <li *ngIf="isMoreLikeThisEnabled" role="menuitem">
	        	<a title="{{LOCALIZATION.viewMoreLike}}" (click)="searchSimilarDocs($event)">{{LOCALIZATION.viewMoreLike}}</a>
	        </li>
	        <ng-container *ngIf="streamingQueries && streamingQueries['enabled']">
	         <li *ngFor="let streamingQueryType of streamingQueries['types']" role="menuitem">
	         	<a title="{{streamingQueryType.displayName}}" 
	         		(click)="searchByStreamingQuery(streamingQueryType.name, streamingQueryType.displayName, $event)">{{streamingQueryType.displayName}}</a>
	         </li>
	        </ng-container>
	        <li *ngIf="cartOn" role="menuitem">
	        	<a title="{{LOCALIZATION.addDocToCart}}" (click)="addToCart($event)">{{LOCALIZATION.addDocToCart}}</a>
	        </li>
	        <li *ngIf="tagsEnabled && userPermissions['ROLE_PRODUCT_UPDATE']" role="menuitem">
	        	<a title="{{LOCALIZATION.viewTags}}" (click)="viewTags($event)">{{LOCALIZATION.viewTags}}</a>
	        </li>
	        <li *ngIf="userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW'] && record.rm_record_id" role="menuitem">
	        	<a title="{{LOCALIZATION.recordInformation}}" (click)="viewRMQuickInfo($event)">{{LOCALIZATION.recordInformation}}</a>
	        </li>
	    </ul>
	</div>
</div>